// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WdHS1","dist":"styles_dist__KbHzo","ratings":"styles_ratings__QBEmY"};